import { Injectable } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/ban-types
declare let gtag: Function;

export interface IGoogleAnalyticsEvent {
  event_name?: string;
  event_category?: string;
  event_action?: string;
  event_label?: string;
  event_value?: any;
}

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  private eventsEnabled = false;

  eventEmitter<T extends IGoogleAnalyticsEvent>(event: T): void {
    if (typeof gtag === 'function' && this.eventsEnabled) {
      const { event_name, ...rest } = event;
      gtag('event', event_name, rest);
    }
  }

  initializeOnStartup(): void {
    if (typeof gtag === 'function') {
      this.eventsEnabled = false;
      gtag('consent', 'default', {
        ad_storage: 'denied',
        analytics_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
      });

      // Load gtag.js script.
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-DCT48J54VR';

      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(gtagScript, firstScript);
    }
  }

  trackPageView(url: string): void {
    if (typeof gtag === 'function' && this.eventsEnabled) {
      gtag('event', 'page_view', { page_path: url });
    }
  }

  enableAnalyticsEvents(): void {
    if (typeof gtag === 'function') {
      this.eventsEnabled = true;
      gtag('consent', 'update', {
        ad_storage: 'granted',
        analytics_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
      });

      gtag('event', 'cookie_consent_enabled', {
        consent_type: 'all',
      });
    }
  }
}
